export default "__VITE_ASSET__CKEa9M$a__"